// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__qbz0B","avatar_type_search":"Avatar_avatar_type_search__UowGb","avatar_type_logo":"Avatar_avatar_type_logo__7Mz8k"};